"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Config = {
    app_url: process.env.MIX_REACT_APP_URL,
    app_url_graphql: process.env.MIX_REACT_APP_URL_GRAPHQL,
    translation_url: process.env.MIX_REACT_TRANSLATION_API_URL,
    app_name: process.env.MIX_REACT_APP_NAME,
};
exports.default = Config;
